module.exports = __webpack_public_path__ + "static/media/mew-LOCAL.63e631dc.png";